import { useQuery } from '@tanstack/react-query';
import { api } from '../api';

export type AlbumSummary = {
  id: string;
  slug: string;
  name: string;
  season: string | null;
  totalStickers: number;
  have: number;
  doubles: number;
};

export function useAlbums() {
  return useQuery({
    queryKey: ['albums'],
    queryFn: () => api<{ albums: AlbumSummary[] }>('/api/albums').then((r) => r.albums),
    staleTime: 30_000,
  });
}
